var map = {
	"./Heading-Five/Modern-Southwestern-Jewelry.js": 86046,
	"./Heading-Four/Charles-Loloma.js": 22686,
	"./Heading-Four/Early-Modernists.js": 52980,
	"./Heading-Four/Preston-Monongye.js": 9547,
	"./Heading-Four/Southwestern-Indian-Art-Project.js": 55494,
	"./Heading-Four/The-Patania-Family-and-the-Thunderbird-Shop-in-Santa-Fe-and-Tucson.js": 44108,
	"./Heading-Four/Thomas-Burnsides.js": 53542,
	"./Heading-Four/White-Hogan-Kenneth-Begay-and-Others.js": 24587,
	"./Heading-One/Wearing-Jewelry.js": 48754,
	"./Heading-Three/Art-Fairs.js": 55467,
	"./Heading-Three/Ashiwi-Zuni-Jewelry.js": 70218,
	"./Heading-Three/Authenticity-Challenges.js": 53632,
	"./Heading-Three/Beaded-Jewelry-For-Sale.js": 64204,
	"./Heading-Three/Cross-Dragonfly-Jewelry.js": 3109,
	"./Heading-Three/Developments-1920s-1950s.js": 92231,
	"./Heading-Three/Dine-Navajo-Jewelry.js": 74845,
	"./Heading-Three/Gerald-Lomaventema-and-Master-Apprentices.js": 24485,
	"./Heading-Three/Hallmarks.js": 56864,
	"./Heading-Three/Hopi-Jewelry.js": 61133,
	"./Heading-Three/Hopi-Overlay.js": 3077,
	"./Heading-Three/Hopicrafts.js": 95503,
	"./Heading-Three/Kewa-Santo-Domingo-Jewelry.js": 29631,
	"./Heading-Three/Michael-Kabotie-And-Artists-Hopid.js": 17040,
	"./Heading-Three/Oodham-Jewelry.js": 80150,
	"./Heading-Three/Rosaries.js": 66118,
	"./Heading-Three/Tribal-Styles.js": 4626,
	"./Heading-Three/Yaqui-Silver-Jewelry-Artists.js": 52155,
	"./Heading-Three/Yaqui-Yoeme-Jewelry.js": 29685,
	"./Heading-Three/Yaqui-Yoeme-Necklaces.js": 89197,
	"./Heading-Two/Ancestral-Pueblo-Shell.js": 10890,
	"./Heading-Two/Ancient-Shell.js": 16557,
	"./Heading-Two/Animal-Forms.js": 61964,
	"./Heading-Two/Copper-and-Brass.js": 98521,
	"./Heading-Two/Coral.js": 31908,
	"./Heading-Two/Gold.js": 531,
	"./Heading-Two/Hohokam-Shell.js": 88190,
	"./Heading-Two/Materials.js": 2767,
	"./Heading-Two/Meaning-of-Turquoise.js": 20479,
	"./Heading-Two/Metals.js": 11720,
	"./Heading-Two/Mogollon-Shell.js": 37989,
	"./Heading-Two/Paquime-Shell.js": 16598,
	"./Heading-Two/Shell-and-Coral.js": 90536,
	"./Heading-Two/Silver.js": 34610,
	"./Heading-Two/Sources-of-Turquoise.js": 25894,
	"./Heading-Two/Spondylus-Shell.js": 30246,
	"./Heading-Two/Stabilized-Turquoise.js": 67818,
	"./Heading-Two/Stone.js": 37736,
	"./Heading-Two/Technological-Changes.js": 95732,
	"./Heading-Two/Turquoise-Beads-Pendants.js": 51799,
	"./Heading-Two/Turquoise-Meets-Silver.js": 98684,
	"./Heading-Two/Turquoise-Mosaics.js": 69163,
	"./Heading-Two/Turquoise-Substitutes.js": 58470,
	"./Heading-Two/Turquoise.js": 52660
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 67681;